import React, { ReactElement } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  useTheme,
} from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { THIRD_PARTY_VEHICLE } from 'data-layer-cr/dist/constants/products';
import { Footer, themeMethods, backgroundThemes } from 'design-system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexFlow: 'column',
      minHeight: '100vh',
    },
    container: {
      flex: 1,
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      background: `linear-gradient(359.66deg, rgba(242, 244, 243,0.4) 13.26%, rgba(255, 255, 255,0.4) 88.97%), 
        ${themeMethods.getCurrentMonthTheme(
          new Date(),
          backgroundThemes.QUOTATION_PAGE,
        )}`,
      [theme.breakpoints.up('lg')]: {
        backgroundPosition: ({
          productType,
        }: {
          productType: string | undefined;
        }) => (productType === THIRD_PARTY_VEHICLE ? 'bottom' : 'initial'),
      },
      [theme.breakpoints.down('sm')]: {
        background: 'none',
      },
    },
  }),
);

interface Props {
  children?: React.ReactNode;
  productId?: string;
}

export default function Layout({ children, productId }: Props): ReactElement {
  /**
   *  To avoid the background from cutting off from the footer, we validate if it is
   *  VehicleRC since it has the shortest height
   * */
  const classes = useStyles({ productType: productId });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <div className={classes.root} data-testid="containerId">
      <div className={classes.container} data-testid="layoutChildrenId">
        {children}
      </div>
      <Footer
        IsMobile={isMobile}
        country="Costa Rica"
        linkText="Consulte nuestros términos y condiciones"
        linkHref="https://www.assanet.cr/condiciones-generales/#seguros-generales"
      />
    </div>
  );
}
